"use client";

import React from "react";
import { Clock, Target, ShieldCheck, CircleCheck, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const serviceDetails = [{
  title: "1. Valitse sopiva koko",
  description: "Selaa laajaa valikoimaamme erikokoisia ja turvallisia varastotiloja Mikkelin parhailla paikoilla.",
  icon: Target,
  items: ["", "Reaaliaikainen saatavuustieto", "Selkeät kuvat ja mitat kohteista"]
}, {
  title: "2. Lähetä varauslomake",
  description: "Löydä budjettiisi sopiva ratkaisu vertailemalla eri kohteiden ominaisuuksia ja hintatasoja.",
  icon: Clock,
  items: ["Läpinäkyvä hinnoittelu ilman kuluja", "", "Valitse tarvitsemasi lisäpalvelut"]
}, {
  title: "3. Varastoi",
  description: "Varmista varastosi helposti ja nopeasti. Saat pääsykoodit suoraan\xA0 sähköpostiisi.",
  icon: ShieldCheck,
  items: ["Turvallinen verkkomaksu heti", "Digitaalinen vuokrasopimus", ""]
}];
export default function ServiceClarity() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="255119" id="näin-vuokraat-helposti" className="py-16 md:py-24 bg-card text-foreground overflow-hidden dark">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        
        {}
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Badge variant="secondary" className="mb-4 bg-primary/10 text-primary hover:bg-primary/20 border-none font-default">
            Vuokrausprosessi
          </Badge>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6 tracking-tight">
            Näin vuokraat <span className="text-primary">helposti ja nopeasti</span>
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed font-serif">
            Varastomikkeli tekee lisätilan hankkimisesta vaivatonta. Seuraa näitä kolmea yksinkertaista vaihetta ja saat tavarasi varastoon nopeallakin aikataululla!
          </p>
          <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670724/img/artifact_img_eqrd8mgg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670724/img/artifact_img_eqrd8mgg.png-wvc-sizes" alt="Storage facility" className="mx-auto mt-12 mb-8 rounded-lg shadow-lg max-w-3xl w-full object-cover md:h-[300px] !w-[665px] !h-[378px]" loading="lazy" decoding="async" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1702718/img/IMG-20260526-WA0001-1.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1702718/img/IMG-20260526-WA0001-1.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1702718/img/IMG-20260526-WA0001-1.png" src="https://varastomikkeli.fi/wp-content/uploads/2026/06/IMG-20260526-WA0001-1.jpg" />
        </div>

        {}
        
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {serviceDetails.map((detail, i) => {
          const Icon = detail.icon;
          return <Card key={i} data-index={i} className="border-border/50 shadow-lg hover:shadow-xl transition-all duration-300 bg-background h-full flex flex-col group rounded-lg">
                <CardHeader className="pb-4">
                  <div className="size-12 rounded-md bg-secondary/10 flex items-center justify-center mb-4 group-hover:bg-secondary/20 transition-colors">
                    <Icon className="size-6 text-secondary" />
                  </div>
                  <CardTitle className="font-default text-xl text-primary font-bold">
                    {detail.title}
                  </CardTitle>
                  <CardDescription className="text-base mt-2 font-serif text-muted-foreground">
                    {detail.description}
                  </CardDescription>
                </CardHeader>
                <CardContent className="mt-auto pt-4 border-t border-border/30">
                  <ul className="space-y-3">
                    {detail.items.map((item, itemIndex) => <li key={itemIndex} data-index={itemIndex} className="flex items-start gap-3">
                        
                        
                      </li>)}
                  </ul>
                </CardContent>
              </Card>;
        })}
        </div>

        {}
        <div className="mt-16 text-center">
          <Button asChild size="lg" className="rounded-md group bg-secondary hover:bg-secondary/90 text-secondary-foreground font-default">
            
          </Button>
        </div>

      </div>
    </section>;
}